import CallHistory from '../../components/call-history/CallHistory';

export default function CallHistoryPage() {
  return <CallHistory />;
}
